export default "__VITE_ASSET__Cdl9vFad__"